import Skeleton from '@/components/ui/Skeleton'
import { FAQ_LIST, FAQ_QUESTION, FAQ_ROW } from '@/screens/courses/components/faq/faq-list-box'

/**
 * Five collapsed questions — the FAQ mm-be seeds holds five, and every
 * question starts closed, so a closed row is the loaded list's own shape
 * (`faq-list-box.ts`: 52px rows, hairlines between). A longer list is taller
 * than this, never shorter than its first five rows.
 *
 * Light on purpose: the route's pending component draws it, and that ships in
 * the entry chunk.
 */
const ROWS = ['w-3/4', 'w-1/2', 'w-2/3', 'w-3/5', 'w-1/2'] as const

export default function FaqListSkeleton() {
  return (
    <div aria-hidden="true" className={FAQ_LIST}>
      {ROWS.map((width, index) => (
        <div key={index} className={FAQ_ROW}>
          <div className={FAQ_QUESTION}>
            <Skeleton className={`h-4 rounded-xs ${width}`} />
            <Skeleton className="size-4 shrink-0 rounded-xs" />
          </div>
        </div>
      ))}
    </div>
  )
}
